import gsap from "gsap/gsap-core";
import React, { useEffect,  useLayoutEffect} from "react";
import styled from "styled-components";
import { ButtonSecondary, devices } from "../../styles";
import TagManager from "react-gtm-module";
import sanitizeHtml from "sanitize-html";
import { swapName } from "../../utils";
import { dictionary } from "../../contexts/site";
import { q8 } from "../../contexts/questions";

export default function Statement({ setShowICS }) {
  
  useEffect(() => {
    // analytics event for page load
    const tagManagerArgs = {
      dataLayer: {
        event: "gaQuizEvent",
        eventAction: "International Statements",
        eventLabel: "International consensus statements on peri-operative ID/IDA management",
      },
    };
    TagManager.dataLayer(tagManagerArgs);
  }, []);



  useLayoutEffect(() => {
    const wrapperAnimation = gsap.fromTo(
      ".wrapper",
      { height: 0 },
      {
        height: document.getElementById('ICS').offsetHeight + 65,
        duration: 0.5,
      }
    );
    wrapperAnimation.then(() => {});
    //let tween = gsap.fromTo(".fadeIn", {autoAlpha: 0}, {autoAlpha: 1, duration: 0.5});
    //tween.delay(1);
  }, []);

  useLayoutEffect(() => {
    gsap.fromTo(".fadeIn", { autoAlpha: 0 }, { autoAlpha: 1, stagger: 0.05 });
  }, []);


  const onBack = () => {
    setShowICS(false);

    /* fade in container
*/    const wrapperAnimation = gsap.fromTo(
      ".wrapper",
      { height: 0 },
      {
        height: document.getElementsByClassName("answer-explanation")[0].offsetHeight + 65,
        duration: 0.5,
      }
    );
    wrapperAnimation.then(() => {});
  };  

  return (
        <div id="ICS">
          <Title className="questionContent fadeIn moveUp" dangerouslySetInnerHTML={{__html: q8.ICS.title}} />
          <Assessment className="questionContent fadeIn moveUp" dangerouslySetInnerHTML={{__html: sanitizeHtml(swapName(q8.ICS.assessment,`surgery`)) }} />
          <p className="questionContent fadeIn moveUp" dangerouslySetInnerHTML={{__html: q8.ICS.recommendation }} />
          <Image>
            <picture>
              <source
                media="(max-width: 767px)"
                srcSet="./statement-idida-mob.svg 767w"
                sizes="767px"
              />
              <source
                srcSet="./statement-idida.svg 1280w"
                sizes="1280px"
              />
              <img 
                width={screen.width > 767 ? "588" : "345" }
                height={screen.width > 767 ? "260" : "917" }
                className="questionContent fadeIn moveUp"  
                src="./statement-idida.svg" 
                alt="International consensus statements on peri-operative ID/IDA management" 
              />
            </picture>
          </Image>
          <Promo className="questionContent fadeIn moveUp" dangerouslySetInnerHTML={{__html: q8.ICS.promo }} />
          <Disclaimer className="questionContent fadeIn moveUp" dangerouslySetInnerHTML={{__html: q8.ICS.disclaimer }} />
          <ButtonSecondary2 
            className="fadeIn moveUp"
            onClick={onBack} 
            replace>
              <span dangerouslySetInnerHTML={{__html: dictionary.buttons.back}} />
          </ButtonSecondary2>
        </div>
  );
}


const Title = styled.h1`
  margin-bottom: 30px;  
  font-style: normal;
  font-weight: 900!important;
  font-size: 22px!important;
  line-height: 28px!important;
  color: ${({ theme }) => theme.secondary} !important;
  text-align: left  !important;`;

 const Image = styled.div`
    img {
      width: 100%;
      height: auto;
      position: relative;
    }
 `;

export const Cell = styled.div`
  width: 100%;

  ul {
    padding-left: 20px;
  }
  ul li {
    list-style-type: disc;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  @media ${devices.S} {
    &:not(:last-child) {
      border-bottom:1px solid ${({ theme }) => theme.light};
    }
  }
  
  }


  @media ${devices.M} {
    width: calc(50% - 15px);

    &:not(:last-child) {
      margin-right: 15px;
    }
  }

  @media ${devices.S} {
    ${Cell}:first-child {
      border-bottom: none;
    }

  }
`;

export const Row = styled.div`
  width: 100%;
  display: flex;
`;

export const Stats = styled.div`
  width: 100%;
  border-collapse: collapse;
  display: flex;
  flex-direction: column;

  @media ${devices.S} {
    font-size: 14px;
  }

  @media ${devices.M} {
    flex-direction: row;
  }

  ${Cell} {
    padding: 15px 0;
  }

  ${Row}:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.light};
  }

  ${Cell}:first-child {
    font-weight: bold;
  }
`;
const ButtonSecondary2 = styled(ButtonSecondary)`
  span {
    padding-right: 0;
    background: none;
  }
  &:hover  span{
    background: none
  }
`;


export const PatientDetails = styled.div`
  background-color: rgb(222, 225, 228);
  border-radius: 8px;
  padding: 15px 15px 0;
  text-align: left;
`;

export const StatsTitle = styled.h2`
  margin-bottom: 20px;
  font-size: 21px;
  line-height: 1.48;

  @media ${devices.M} {
    font-size: 24px;
    line-height: 1.58;
  }

  @media ${devices.L} {
    font-size: 28px;
    line-height: 1.5;
  }
`;

const Disclaimer = styled.p`
  text-align: left;
  font-size: 12px;
  margin-top: 8px;
`;

const Assessment = styled.div`
  p {
    align-items: left;
    background-color: #FFFFFF;
    background-repeat: no-repeat;
    background-position: center left 15px;
    border-radius: 6px;
    border: 2px solid  ${({ theme }) => theme.secondary};
    color: ${({ theme }) => theme.body};
    display: inline-block;
    //flex-direction: column;
    font-style: normal;

    font-size: 16px;
    line-height: 24px;
    padding: 18px;
    position: relative;
    span {
      color: ${({ theme }) => theme.primary};
      font-weight: 700;
    }
  }
`;

const Promo = styled.div`
  margin: 16px 0 0;
  p {
    display: flex;
    flex-direction: column;
    align-items: left;
    padding: 18px;
    margin-bottom: 0px;
    background-color: #FFFFFF;
    background-repeat: no-repeat;
    background-position: center left 15px;
    border-radius: 6px;
    font-style: normal;
    font-size: 16px;
    line-height: 24px;
    position: relative;
    display: inline-block;
    background-color: ${({ theme }) => theme.primary};
    color: white;

    strong {
      font-weight: 800;
    }
  }
`;
